import * as actionTypes from './actionType';

export const getPropertyByYear = (id, startDate, endDate, lyStartDate, lyEndDate) => ({
    type: actionTypes.GET_PROPERTY_BY_YEAR,
    id,
    startDate,
    endDate,
    lyStartDate,
    lyEndDate,
});

export const getPropertyByMonth = (id, startDate, endDate, lyStartDate, lyEndDate) => ({
    type: actionTypes.GET_PROPERTY_BY_MONTH,
    id,
    startDate,
    endDate,
    lyStartDate,
    lyEndDate,
});

export const getPropertySuccess = (actionType, payload) => ({
    type: actionType,
    payload,
});

export const getOTAInsightsByDay = (id, date) => ({
    type: actionTypes.GET_OTA_INSIGHTS_DAILY,
    id,
    date,
});
